/* Kasutam theme — shared utilities used by header.js, cart.js, product-form.js, etc. */
(function () {
  'use strict';

  window.Kasutam = window.Kasutam || {};
  var lockCount = 0;
  var releaseFocus = null;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function fetchConfig(type) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') }
    };
  }

  function trapFocus(container, autofocusEl) {
    var focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener('keydown', onKeydown);
    (autofocusEl || first).focus();
    return function release() {
      container.removeEventListener('keydown', onKeydown);
    };
  }

  function lockBodyScroll() {
    lockCount++;
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) document.documentElement.style.overflow = '';
  }

  function escListener(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.is-open').forEach(function (el) {
        closeOverlay(el);
      });
    }
  }

  function openOverlay(el, opts) {
    opts = opts || {};
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    lockBodyScroll();
    releaseFocus = trapFocus(el, opts.autofocusEl);
    document.addEventListener('keydown', escListener);
    el.__lastTrigger = opts.trigger || document.activeElement;
    if (opts.trigger) opts.trigger.setAttribute('aria-expanded', 'true');
  }

  function closeOverlay(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    unlockBodyScroll();
    if (releaseFocus) releaseFocus();
    document.removeEventListener('keydown', escListener);
    var trigger = el.__lastTrigger;
    if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      el.hidden = true;
      if (trigger && typeof trigger.focus === 'function') trigger.focus();
    }, 300);
  }

  window.Kasutam.utils = {
    debounce: debounce,
    fetchConfig: fetchConfig,
    trapFocus: trapFocus,
    openOverlay: openOverlay,
    closeOverlay: closeOverlay
  };

  // ---- Generic disclosure (details/summary) animation helper class toggle ----
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-accordion] > summary').forEach(function (summary) {
      summary.addEventListener('click', function () {
        var details = summary.closest('details');
        var group = details.closest('[data-accordion-group]');
        if (group && !details.open) {
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });
  });

  // ---- Collection sort dropdown ----
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    });
  });
})();
